import * as React from 'react';
import DrawerMUI from '@material-ui/core/Drawer';

import CloseButton from '../close-button';
import {
	Root,
	Content,
	CloseButtonLayout,
} from './styled';


type AnchorType = 'top' | 'bottom';

export type ActionPanelProps = {
	ref?: any;
	stateForMerge?: ActionPanelState;
}

export type ActionPanelState = {
	isOpen?: boolean;
	anchor?: AnchorType;
	content?: React.ReactNode;
}

class ActionPanelBase extends React.Component<ActionPanelProps, ActionPanelState> {
	static displayName = 'ActionPanelBase';
	static defaultProps = {
		defaultOpen: false,
	};
	state = {
		isOpen: false,
		anchor: 'bottom' as AnchorType,
		content: null,
		...(this.props.stateForMerge || {})
	};

	public open = (state: Partial<ActionPanelState>) => this.setState({ ...state, isOpen: true });

	public close = () => {
		this.setState({ isOpen: false });
		setTimeout(() => this.reset(), 200);
	};

	public reset = () => this.setState({ content: null });

	public setContent = (state: Partial<ActionPanelState>) => this.setState({ ...state });

	render() {
		const {
			isOpen,
			anchor,
			content,
		} = this.state;

		return (
			<Root>
				<DrawerMUI
					open={isOpen}
					anchor={anchor}
					PaperProps={{
						style: {
							width: '100%',
							maxWidth: '100%'
						}
					}}
					ModalProps={{
						hideBackdrop: true,
						disablePortal: true,
						onClose: (_, reason: string) => {
							if (reason !== 'backdropClick') {
								this.close();
							}
						}
					}}
					onClose={this.close}>
					{content}
					<CloseButtonLayout>
						<CloseButton onClick={this.close} />
					</CloseButtonLayout>
				</DrawerMUI>
			</Root>
		);
	}
};

const panels = {
	actionPanel: null,
};

const setActionPanelRef = ref => (panels.actionPanel = ref);
const getActionPanel = () => panels.actionPanel;

const ActionPanel = {
	Base: ActionPanelBase,
	Content,
	setRef: setActionPanelRef,
	get: getActionPanel,
};

export default ActionPanel;
